import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { FlatButton, IconButton, Table, TableHeader, TableRow, TableBody, TableHeaderColumn, TableRowColumn, FontIcon, MenuItem } from 'material-ui';
import ArrowDropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import R, { propOr, isNil, remove } from 'ramda';
import FlatDropDownMenu from '../../../tc-ui/flatDropDownMenu';

const ReviewPartners = props => {
  const {
    updateProps,
    sendToPartners,
    actionItems,
    validityCheckFn,
  } = props;
  // workaround for dropdown menu not closing
  const hideDropdownMenu = Boolean(sendToPartners.showAddIndividuallyDialog
    || sendToPartners.showSelectFromPartnersDialog
    || sendToPartners.showUploadFileDialog
    || sendToPartners.showEmailImportDialog);

  return (
    <div style={{ marginTop: '15px' }}>
      <div>
        {
          hideDropdownMenu ? <span/> :
            <FlatDropDownMenu
              button={
                <FlatButton
                  data-cy="selectMorePartners"
                  label={<span style={{ color: '#00bcd4' }}>+ ADD MORE PARTNERS</span>}
                  labelPosition="before"
                  icon={<ArrowDropDownIcon style={{ fill: 'rgba(0, 0, 0, 0.54)' }}/>}
                  style={{ borderRadius: '4px' }}
                  backgroundColor="#f4f5f7"
                  labelStyle={{ textTransform: 'none' }}
                />
              }
            >
              {
                actionItems.map((actionItem, index) => (
                  <MenuItem
                    data-cy={actionItem.cyData}
                    key={index}
                    onClick={actionItem.func}
                    value={index}
                    primaryText={actionItem.text}
                    leftIcon={actionItem.svgIcon || <FontIcon className={actionItem.icon} style={{ color: '#757575' }} />}
                  />
                ))
              }
            </FlatDropDownMenu>
        }
      </div>
      <div>
        <Table style={{ backgroundColor: 'rgba(244, 244, 244, 0.24)' }}>
          <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn>Company Name/Email</TableHeaderColumn>
              <TableHeaderColumn>Company Type</TableHeaderColumn>
              {
                validityCheckFn ? <TableHeaderColumn style={{ padding: '0' }}>Validity</TableHeaderColumn> : <TableHeaderColumn/>
              }
              <TableHeaderColumn/>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {
              propOr([], 'partnersToSendTo', sendToPartners)
              .filter((_, i, arr) => (arr.length < 31 || sendToPartners.showAllInReview) || i < 31)
              .map((obj, i) => {
                const errors = validityCheckFn ? validityCheckFn(obj) : '';
                return (
                  <TableRow key={`${obj.email}${i}`} style={{ height: '32px' }}>
                    <TableRowColumn style={{ height: '32px', fontSize: '14px' }}>
                      {obj.company_name || obj.companyName || obj.email}
                    </TableRowColumn>
                    <TableRowColumn style={{ height: '32px', fontSize: '14px' }}>
                      {obj._type || <i>Not on TourConnect</i>}
                    </TableRowColumn>
                    <TableRowColumn style={{ height: '32px', fontSize: '14px', color: R.call(R.cond([
                      [() => isNil(errors), R.always('green')],
                      // [() => R.equals(errors, '* Contract exists'), R.always('#c07942')],
                      [R.T, R.always('red')],
                    ])), padding: '0' }}
                    >
                      {isNil(errors) ? 'valid' : errors}
                    </TableRowColumn>
                    <TableRowColumn style={{ height: '32px', fontSize: '14px', textAlign: 'right' }}>
                      <IconButton
                        iconClassName="tc-icon-delete2"
                        iconStyle={{ color: 'rgb(255, 64, 129)' }}
                        onTouchTap={() => updateProps({
                          partnersToSendTo: remove(i, 1, sendToPartners.partnersToSendTo),
                        })}
                      />
                    </TableRowColumn>
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Table>
        {
          sendToPartners.partnersToSendTo && sendToPartners.partnersToSendTo.length > 30 ? (
            <div
              style={{ lineHeight: '48px', color: '#00bcd4', cursor: 'pointer' }}
              onClick={() => updateProps({ showAllInReview: !sendToPartners.showAllInReview })}
            >
              {sendToPartners.showAllInReview ? 'Show Less' : 'Show All'}
            </div>
          ) : <div/>
        }
      </div>
    </div>
  );
};

ReviewPartners.propTypes = {
  updateProps: PropTypes.func,
  sendToPartners: PropTypes.object,
  actionItems: PropTypes.array,
  clearReducer: PropTypes.func,
  validityCheckFn: PropTypes.func,
  billingPlan: PropTypes.string,
  isSupplier: PropTypes.bool,
};

const mapStateToProps = ({ contracting, user }) => ({
  billingPlan: user.get('billingPlan'),
  sendToPartners: contracting.sendToPartners.toJS(),
});

export default connect(mapStateToProps)(ReviewPartners);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/send-to-partners/review-partners.jsx